const defaultConfig = {
  env: 'test',
  baseUrl: 'https://test-api.dimorder.com',
  nodeApiUrl: 'https://test-node.dimorder.com',
  basePriceUrl: 'https://test-delivery-price.dimorder.com',
}

export default defaultConfig
